import axios from "axios";

export default axios.create({
  baseURL: "https://breweryfinder-api.onrender.com",
});
